import { render, staticRenderFns } from "./DataDictionary.vue?vue&type=template&id=3228a4da&scoped=true"
import script from "./DataDictionary.vue?vue&type=script&lang=js"
export * from "./DataDictionary.vue?vue&type=script&lang=js"
import style0 from "./DataDictionary.vue?vue&type=style&index=0&id=3228a4da&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3228a4da",
  null
  
)

export default component.exports